<template>
    <div>
       <v-card color="grey lighten-4">
            <v-snackbar :timeout="timeout" :color="color" :left="left" v-model="snackbar">{{ message }}</v-snackbar>
            <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
        </v-card>
     <v-container>
     		<!-- Form -->
		<v-card>
			<v-card-title>
				<span class="headline">{{ formTitle }}</span>
			</v-card-title>
			<v-form v-model="valid" ref="form" lazy-validation>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
                            <v-flex xs12 sm4 md4>							
                                <v-text-field 
                                    label="Vat *" 
                                    v-model="formSchema.vat" 
                                    :rules="grossRules" 
                                    required>
                                </v-text-field> 
                            </v-flex>
                            <v-flex xs12 sm4 md4>							
                                <v-text-field 
                                    label="Tax *" 
                                    v-model="formSchema.tax" 
                                    :rules="grossRules" 
                                    required>
                                </v-text-field> 
                            </v-flex>	
                            <v-flex xs12 sm4 md4>							
                                <v-text-field 
                                    label="Service Charge *" 
                                    v-model="formSchema.charge" 
                                    :rules="grossRules" 
                                    required>
                                </v-text-field> 
                            </v-flex>					
						</v-layout>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="success" @click.native="validateBeforeSubmit">{{buttonTitle}}</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
		<!-- /Form -->  
     </v-container>
      
    </div>
</template>
<script>
/**
 * ---------------------
 *  implements by majeed
 * ---------------------
 */
const commonService = require('../../../services/common.service');

import {preFix} from '../../../vuex/api'
import Axios from 'axios'
export default {
    data: () => ({
      isActiveVal: 0, 
      valid: true,
      dialog: false,
      dialogEditForm:false,

      search: '',
      totalItems: 0,      
      loading: true,

      pagination: {
        sortBy: 'id',
        descending:true,
      },
      selected:[],
      search:'',      
      headers: [
      {
        text: 'Name',
        align: 'left',
        sortable: false,
        value: 'name'
      },
      { text: 'User Type', align: 'left', value: 'type_id' },
      { text: 'Email', value: 'email' },
      
      ],

      formSchema:{
          id:'',
          vat:'',
          tax:'',
          charge:''
      },

      areaList:[
          {id:1, text:'Dhaka Metro'},
          {id:2, text:'Chattogram'},
          {id:3, text:'Khulna'},
          {id:4, text:'Syhlet'},
          {id:5, text:'Barisal'},
          {id:6, text:'Rajshahi'},
          {id:7, text:'Rangpur'},
          {id:8, text:'Narayanganj'},
          {id:9, text:'Gazipur'},
          {id:10, text:'Savar Poroushova'},
          {id:11, text:'Others Area'},

      ],
      
      delete_id:'',
      row_index:'',
      dialog2: false,
      snackbar: false,
      color: 'success',
      mode: '',
      timeout: 3000,
      left:'left',
      message: '',

      SnackbarVal: {
        snackbar: false,
        color: "success",
        message: "",
      },

      select: null,
      instituteList: [],

      typelist:[],

      grossRules: [
        v => !!v || "Data is required",
        v => /^[1-9]\d*(\.\d+)?$/.test(v) || "Data must be valid"
      ],
      areaRules: [
          v => !!v || 'Area is required',
        ],
      instituteShow:true,
    }),

    computed: {
      formTitle () {
        return this.formSchema.id > 0 ? 'Administration Settings' : 'Administration Settings'
      },
      buttonTitle () {
        return this.formSchema.id > 0 ? 'Update' : 'Save'
      },
    },

    mounted(){
        this.getData();
    },
   
    methods: {
       changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },

      validateBeforeSubmit(e) {
        var formSchema = this.formSchema;
        var root = this
        if (this.$refs.form.validate()) {
            commonService.insertFormData(formSchema, 'adm_settings').then(res => {							
                this.SnackbarVal.color = "success";
                this.SnackbarVal.message = res.message;
                this.SnackbarVal.snackbar = true;
            });
            //this.getData();
        }  

      },
      getData(){
        commonService.getAllData('get_adm_settings').then(res => {                                    
            var data = res.data;
            this.formSchema.vat = data.vat;
            this.formSchema.tax = data.tax;
            this.formSchema.charge = data.charge;
            this.loading = false;
        });
      },

    },

    watch:{
      // props re-activity 
      item (){
         this.formSchema = this.item
         console.log(this.formSchema)
      }
    },

}
</script>


// WEBPACK FOOTER //
// src/components/administration/settings/adm_setting.vue